<template>
  <div class="code-insee-input">
    <qd-loader :active="isLoading">
      <b-field :label="label" :message="message" :type="message ? 'is-primary' : ''">
        <b-tooltip
          :label="messageError"
          :active="!!messageError"
          :type="!!messageError ? 'is-danger' : ''"
          position="is-right"
          class="tooltip-error">
          <b-input v-model="adresse.codeInsee" class="width-100percent"></b-input>
          <qd-button
            class="double-sticky-button-left"
            type="is-default"
            icon-right="magnify"
            @click="getCodeInsee">
          </qd-button>
        </b-tooltip>
      </b-field>
    </qd-loader>
    <b-modal
      v-model="popUpChoixCodeInsee"
      has-modal-card
      class="modal">
      <div class="card width-960">
        <div class="pd-0">
          <header class="bandeau-modal card-header"></header>
          <div class="center mgt-20px">
            <h1 class="title is-size-3">
              {{this.$t('general.composants.codeInseeInput.codeInsee')}}
            </h1>
          </div>
          <div class="card-content">
            <b-table
                :data="listeCodeInsee"
                :columns="columns"
                focusable
                selectable
                @select="selected"
                :paginated="true"
                per-page=10>
            </b-table>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import getCommune from '@/api/apigouvfr/index';

export default {
  props: {
    label: {
      type: String,
      default: '',
    },
    adresse: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      popUpChoixCodeInsee: false,
      isLoading: false,
      listeCodeInsee: [],
      columns: [{
        field: 'code',
        label: this.$t('general.composants.codeInseeInput.codeInsee'),
      },
      {
        field: 'nom',
        label: this.$t('general.composants.codeInseeInput.ville'),
      },
      {
        field: 'codeDepartement',
        label: this.$t('general.composants.codeInseeInput.departement'),
      }],
      message: null,
      messageError: null,
    };
  },
  methods: {
    selected(item) {
      this.popUpChoixCodeInsee = false;
      this.$set(this.adresse, 'codeInsee', item.code);
    },
    async getCodeInsee() {
      this.isLoading = true;
      this.message = null;
      this.messageError = null;
      try {
        const infoCommune = await getCommune(
          this.adresse.ville,
          this.adresse.codePostal?.substring(0, 2),
        );
        if (infoCommune.data.length === 0) {
          this.message = this.$t('general.composants.codeInseeInput.message');
        }
        if (infoCommune.data.length === 1) {
          this.$set(this.adresse, 'codeInsee', infoCommune.data[0].code);
        }
        if (infoCommune.data.length > 1) {
          this.listeCodeInsee = infoCommune.data.sort((a, b) => a.code > b.code);
          this.popUpChoixCodeInsee = true;
        }
      } catch (error) {
        this.messageError = this.$t('general.composants.codeInseeInput.messageError');
        throw error;
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style>
</style>
